import { getIconBaseProps } from '../utils';

export const cryptos = {
  ...getIconBaseProps('cryptos'),
  width: '22px',
  height: '22px',
  viewBox: '0 0 22 22',
  fill: 'currentColor',
  xmlns: 'http://www.w3.org/2000/svg',
  body: (
    <>
      <path
        d='M11 18.5C15.4183 18.5 19 14.9183 19 10.5C19 6.08172 15.4183 2.5 11 2.5C6.58172 2.5 3 6.08172 3 10.5C3 14.9183 6.58172 18.5 11 18.5Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.20947 7.74615H11.9227C12.6834 7.74615 13.2998 8.36262 13.2998 9.12328C13.2998 9.88394 12.6834 10.5004 11.9227 10.5004H8.95217'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.20947 13.2541H12.4136C13.1741 13.2541 13.7907 12.6377 13.7907 11.877C13.7907 11.1163 13.1743 10.4999 12.4136 10.4999H9.1036'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.94727 6.20886V7.74619'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5273 6.20886V7.74619'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.94727 13.2544V14.7917'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5273 13.2544V14.7917'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.95117 7.74615V10.5004V13.2547'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  ),
};
